import './patch';
import ReactDOM from 'react-dom/client';
import { ApolloProvider } from '@apollo/client';
import { client } from './graphql/client';
import { BrowserRouter as Router } from 'react-router-dom';
import { initLocale } from './i18n-next';
import { MantineProvider } from '@mantine/core';
import { ModalsProvider } from '@mantine/modals';
import { theme } from './theme';
import { Notifications } from '@mantine/notifications';
import { DatesProvider } from '@mantine/dates';
import i18n from 'i18next';
import { QueryClientProvider } from '@tanstack/react-query';
import ErrorBoundary from '@/ui/ErrorBoundary';
import { queryClient } from './util/reactQuery';
import { Suspense } from 'react';
import { safeLazy } from './components/SafeLazy/SafeLazy';
import 'dayjs/locale/it';
import './index.css';
import './util/broadcast-channel';
import { initialProfile } from './hooks/useProfile';
import i18next from 'i18next';
// Import styles of packages that you've installed.
// All packages except `@mantine/hooks` require styles imports
import '@mantine/core/styles.css';
import '@mantine/carousel/styles.css';
import '@mantine/notifications/styles.css';
import '@mantine/dates/styles.css';
import { trpc, trpcClient } from './trpc/trpc';
// import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import App from './App';
import Splash from './pages/Splash/Splash';
import { Helmet } from 'react-helmet';

const CookiesBanner = safeLazy(() => import('./alerts/CookiesBanner'));

const Analytics = safeLazy(() => import('./components/Analytics'));

const Index = () => {
  return (
    <>
      <Helmet>
        <title>{import.meta.env.VITE_APP_NAME}</title>
      </Helmet>
      <trpc.Provider client={trpcClient} queryClient={queryClient}>
        <QueryClientProvider client={queryClient}>
          {/*<ReactQueryDevtools buttonPosition="bottom-left" initialIsOpen={false} />*/}
          <ApolloProvider client={client}>
            <MantineProvider theme={theme}>
              <Router>
                <DatesProvider settings={{ locale: i18n.language, consistentWeeks: true }}>
                  <Suspense>
                    <CookiesBanner />
                  </Suspense>
                  <Notifications limit={4} autoClose={2000} />
                  <ErrorBoundary>
                    <ModalsProvider>
                      <Suspense>
                        <Analytics />
                      </Suspense>
                      <Suspense fallback={<Splash />}>
                        <App />
                      </Suspense>
                    </ModalsProvider>
                  </ErrorBoundary>
                </DatesProvider>
              </Router>
            </MantineProvider>
          </ApolloProvider>
        </QueryClientProvider>
      </trpc.Provider>
    </>
  );
};

// Change to sign-up component to build only the user registration page
const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);

initLocale
  .then(async () => {
    const profile = await initialProfile();
    if (profile === null) {
      i18next.loadNamespaces('content');
    }
  })
  .then(() => root.render(<Index />));
